module.exports = __webpack_public_path__ + "img/poster_bg_3.931bbe53.png";